<template>
    <slot v-bind="{
        ...state,
        handleClick,
    }" />
</template>

<script setup>
import { onBeforeMount, onBeforeUnmount, reactive } from 'vue';

import favorites from '../services/favorites';
import zonedDate from '../utils/zoned-date';
import { isValid } from 'date-fns';

const now = zonedDate();

const props = defineProps({
    instances: {
        type: Array,
        required: true,
    },
});

const state = reactive({
    performances: [],
    hasFavorites: false,
});

const handleClick = () => {
    window.dispatchEvent(new CustomEvent('showEventFavoriteDialog', {
        detail: {
            performances: state.performances,
        },
    }));
}

const handleFavoritesChange = () => {
    state.hasFavorites = state.performances.some(performance => {
        return favorites.isFavoritePerformance(performance);
    });
}

onBeforeMount(() => {
    if (!props.instances || !props.instances.length) {
        return;
    }

    for (const instance of props.instances) {
        const id = parseInt(instance[0], 10);
        const date = instance[1] instanceof Date ? instance[1] : zonedDate(instance[1]);
        const enabled = instance[2];

        if (!id || !isValid(date) || date < now) {
            continue;
        }

        state.performances.push({
            id,
            date,
            enabled,
        });
    }

    handleFavoritesChange();

    window.addEventListener(favorites.favoritePerformancesChangedEventName, handleFavoritesChange);
});

onBeforeUnmount(() => {
    window.removeEventListener(favorites.favoritePerformancesChangedEventName, handleFavoritesChange);
});
</script>
